export const VIDEO_MAKING_PHONES = ["9640717460","7396019228"];

export const canAccessVideoMaking = () => {
  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  ) {
    return true;
  }
  const phone = localStorage.getItem("num") || "";
  return VIDEO_MAKING_PHONES.includes(String(phone).trim());
};
